import { useTableStore } from '@features/tables/stores/useTableStore'
import { useViewStore } from '@features/views/stores/useViewStore'
import {
  useSettingsStore,
  clearCachedConfigurations,
} from '@features/settings/stores/useSettingsStore'
import { usePreferenceEditingStore } from '@features/settings/stores/usePreferenceEditingStore'
import { usePermissionsStore } from '@features/permissions/stores/usePermissionsStore'
import { useTableOrganizationStore } from '@features/sidebar/stores/useTableOrganizationStore'

const featureStoreResets = new Set<() => void>()

/**
 * Resets a store that loads with its feature's code, not with the app, at
 * each sign-in with the stores here. One that never loaded has nothing to reset.
 */
export function resetWithAuthenticatedStores(reset: () => void) {
  featureStoreResets.add(reset)
}

// Table search state lives in per-table providers inside the identity-keyed
// app tree, so it starts fresh for each sign-in without a reset here.
export function resetAuthenticatedStores() {
  useTableStore.setState(useTableStore.getInitialState(), true)
  useViewStore.getState().reset()
  usePreferenceEditingStore.getState().resetPreferenceEditing()
  useSettingsStore.getState().resetSettings()
  usePermissionsStore.setState(usePermissionsStore.getInitialState(), true)
  useTableOrganizationStore.setState({ draftFolders: null, isOrganizing: false, isDirty: false })
  for (const reset of featureStoreResets) reset()
  clearCachedConfigurations()
}
